import api from './api'
import moment from 'moment'

function list() {
  return api.get('/admin/usage-terms')
}

function create(body) {
  return api.post('/admin/usage-terms', body)
}

function show(id) {
  return api.get(`/admin/usage-terms/${id}`)
}

function update(body) {
  return api.put(`/admin/usage-terms/${body.id}`, body)
}

export default {
  list,
  create,
  show,
  update,
}
